import React from "react";

export const PopoverDrawerContext = React.createContext({
	isChildren: false,
});
